import { storeWrapper } from '../storeWrapper'

const initialState = {
  menuPanels: null,
  panelHeadings: null,
  mouseOverTimeout: null,
  open: false
}

export const useNavigationStore = storeWrapper('useNavigationStore', (set, get) => ({
  ...initialState,
  setMenuPanels: (menuPanels) => set({ menuPanels }),
  setPanelHeadings: (panelHeadings) => set({ panelHeadings }),
  setMouseOverTimeout: (mouseOverTimeout) => set({ mouseOverTimeout }),
  setOpen: (open) => set({ open }),
  handleHover: (panelItem, index) => {
    // add a delay before showing the menu so it doesn't change when people quickly move to the next menu item
    const mouseOutTimeout = setTimeout(() => {
      if (!open) {
        clearTimeout(get().mouseOverTimeout)
        return
      }

      if (get().menuPanels?.length) {
        const menuPanelsClone = get().menuPanels.filter((_, i) => i <= index)
        if (panelItem?.children) menuPanelsClone[index + 1] = panelItem.children
        get().setMenuPanels([...menuPanelsClone])
      }

      if (get().panelHeadings?.length) {
        const panelHeadingsClone = get().panelHeadings.filter((_, i) => i <= index)
        if (panelItem?.label) panelHeadingsClone[index + 1] = panelItem.label
        get().setPanelHeadings([...panelHeadingsClone])
      }
    }, 200)

    get().setMouseOverTimeout(mouseOutTimeout)
  },
  reset: () => set(initialState)
}))
